import { render, staticRenderFns } from "./OrganizationsList.vue?vue&type=template&id=2fc3a66e&scoped=true"
import script from "./OrganizationsList.vue?vue&type=script&lang=js"
export * from "./OrganizationsList.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsList.vue?vue&type=style&index=0&id=2fc3a66e&prod&lang=scss&scoped=true"
import style1 from "./OrganizationsList.vue?vue&type=style&index=1&id=2fc3a66e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3a66e",
  null
  
)

export default component.exports